import { createAction, props } from '@ngrx/store';
import { ILoaderActionPayload } from '../models/loader.model';
import {
  AddressBookItem,
  AddressBookListResponse,
  CompanyAssignedUsersResponse,
  CompanyItem,
  CompanyListResponse,
  CompanyTypeResponse,
} from '../../../api/models';

import { enumCompanyType } from '../../shared/enum/enum-company-type';
import {
  CompanyControllerAddLogo$Params,
  CompanyControllerAddUsers$Params,
  CompanyControllerCreate$Params,
  CompanyControllerDelete$Params,
  CompanyControllerFind$Params,
  CompanyControllerForceDelete$Params,
  CompanyControllerGetAllDeleted$Params,
  CompanyControllerRemoveUsers$Params,
  CompanyControllerRestore$Params,
  CompanyControllerUpdate$Params,
} from '../../../api/functions';

export const companiesActions = {
  load: createAction('load/companies', props<CompanyControllerFind$Params>()),
  done: createAction('load/companies/done', props<{ state: ILoaderActionPayload; data?: CompanyListResponse }>()),
  loadOne: createAction('load/companies/load-one', props<{ id: number }>()),
  doneOne: createAction('load/companies/done-one', props<{ state: ILoaderActionPayload; data?: CompanyItem }>()),
  loadOneSetState: createAction('companies/load-one/state', props<{ state: ILoaderActionPayload }>()),
  loadUsers: createAction('load/companies/users', props<{ id: number; limit: number; skip: number; query: string }>()),
  loadUsersDone: createAction(
    'load/companies/users/done',
    props<{ state: ILoaderActionPayload; data?: CompanyAssignedUsersResponse }>(),
  ),
  assignUsers: createAction('companies/assign-users', props<CompanyControllerAddUsers$Params>()),
  assignUsersDone: createAction('companies/assign-users/done', props<{ state: ILoaderActionPayload }>()),
  assignUsersSetState: createAction('companies/assign-users/state', props<{ state: ILoaderActionPayload }>()),
  unassignUsers: createAction('companies/unassign-user', props<CompanyControllerRemoveUsers$Params>()),
  unassignUsersDone: createAction('companies/unassign-user/done', props<{ state: ILoaderActionPayload }>()),
  unassignUsersSetState: createAction('companies/unassign-user/state', props<{ state: ILoaderActionPayload }>()),
  // loadAddressBook: createAction(
  //   'load/companies/address-book/load',
  //   props<CompanyControllerFindAddressBookItems$Params>(),
  // ),
  loadAddressBookDone: createAction(
    'load/companies/address-book/done',
    props<{ state: ILoaderActionPayload; data?: AddressBookListResponse }>(),
  ),
  // addContactoToAddressBook: createAction(
  //   'load/companies/address-book/add',
  //   props<CompanyControllerCreateAddressBookItem$Params>(),
  // ),
  addContactoToAddressBookDone: createAction(
    'load/companies/address-book/add/done',
    props<{ state: ILoaderActionPayload; data?: AddressBookItem }>(),
  ),
  addContactoToAddressBookSetState: createAction(
    'load/companies/address-book/add/state',
    props<{ state: ILoaderActionPayload }>(),
  ),
  // loadOneAddressBookContact: createAction(
  //   'load/companies/address-book/load-one',
  //   props<CompanyControllerFindOneAddressBookItem$Params>(),
  // ),
  loadOneDoneAddressBookContact: createAction(
    'load/companies/address-book/load-one/done',
    props<{ state: ILoaderActionPayload; data?: AddressBookItem }>(),
  ),
  loadOneDoneAddressBookContactSetState: createAction(
    'load/companies/address-book/load-one/state',
    props<{ state: ILoaderActionPayload }>(),
  ),

  // saveOneAddressBookContact: createAction(
  //   'load/companies/address-book/save-one',
  //   props<CompanyControllerUpdateAddressBookItem$Params>(),
  // ),
  saveOneDoneAddressBookContact: createAction(
    'load/companies/address-book/save-one/done',
    props<{ state: ILoaderActionPayload; data?: AddressBookItem }>(),
  ),
  saveOneDoneAddressBookContactSetState: createAction(
    'load/companies/address-book/save-one/state',
    props<{ state: ILoaderActionPayload }>(),
  ),
  saveOne: createAction('companies/save-one', props<CompanyControllerUpdate$Params>()),
  saveOneDone: createAction('companies/save-one/done', props<{ state: ILoaderActionPayload; data?: CompanyItem }>()),
  saveOneSetState: createAction('companies/save-one/state', props<{ state: ILoaderActionPayload }>()),
  createOne: createAction('companies/create-one', props<CompanyControllerCreate$Params>()),
  createOneDone: createAction(
    'companies/create-one/done',
    props<{ state: ILoaderActionPayload; data?: CompanyItem }>(),
  ),
  createOneSetState: createAction('companies/create-one/state', props<{ state: ILoaderActionPayload }>()),
  uploadLogo: createAction('companies/update-logo', props<CompanyControllerAddLogo$Params>()),
  uploadLogoDone: createAction(
    'companies/update-logo/done',
    props<{ state: ILoaderActionPayload; data?: CompanyItem }>(),
  ),
  uploadLogoFail: createAction('companies/update-logo/fail', props<{ state: ILoaderActionPayload }>()),
  uploadLogoSetState: createAction('companies/update-logo/state', props<{ state: ILoaderActionPayload }>()),
  deleteOne: createAction('companies/delete-one', props<CompanyControllerDelete$Params>()),
  deleteOneDone: createAction(
    'companies/delete-one/done',
    props<{ state: ILoaderActionPayload; data?: CompanyItem }>(),
  ),
  deleteOneSetState: createAction('companies/delete-one/state', props<{ state: ILoaderActionPayload }>()),
  loadTrash: createAction('load/companies/trash', props<CompanyControllerGetAllDeleted$Params>()),
  loadTrashDone: createAction(
    'load/companies/trash/done',
    props<{ state: ILoaderActionPayload; data?: CompanyListResponse }>(),
  ),
  restoreOneFromTrash: createAction('companies/trash/restore-one', props<CompanyControllerRestore$Params>()),
  restoreOneFromTrashDone: createAction(
    'companies/trash/restore-one/done',
    props<{ state: ILoaderActionPayload; data?: CompanyItem }>(),
  ),
  restoreOneFromTrashSetState: createAction(
    'companies/trash/restore-one/state',
    props<{ state: ILoaderActionPayload }>(),
  ),
  deleteOneFromTrash: createAction('companies/trash/delete-one', props<CompanyControllerForceDelete$Params>()),
  deleteOneFromTrashDone: createAction(
    'companies/trash/delete-one/done',
    props<{ state: ILoaderActionPayload; data?: CompanyItem }>(),
  ),
  deleteOneFromTrashSetState: createAction(
    'companies/trash/delete-one/state',
    props<{ state: ILoaderActionPayload }>(),
  ),
  loadGetTypes: createAction('load/companies/types'),
  doneGetTypes: createAction(
    'load/companies/types/done',
    props<{ state: ILoaderActionPayload; data?: CompanyTypeResponse }>(),
  ),
};
